import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingRgbColorPickerFromImageConfig } from '@/data/landingConfig/landingRgbColorPickerFromImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_RgbColorPickerFromImage } from './schemaObject';

interface Props {}
const RgbColorPickerFromImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_RgbColorPickerFromImage} />
			<LandingTemplate
				data={landingRgbColorPickerFromImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelColorPicker()}
			/>
		</>
	);
};

export default RgbColorPickerFromImage;
